// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2111":"9c0229b8e92d1982","7260":"2c9d03a433dc9f65"}[chunkId] + ".css";
};